import { useSyncExternalStoreWithSelector } from "use-sync-external-store/shim/with-selector";
import { useStore } from "./use-store";
function useSelector(selector) {
  const store = useStore();
  return useSyncExternalStoreWithSelector(store.subscribe, store.getState, store.getState, selector);
}
export {
  useSelector
};
//# sourceMappingURL=use-selector.js.map